module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "zan-cell",
    attrs: {
      "href": _vm.url
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "zan-cell__title"
  }, [_vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "zan-icon",
    class: 'zan-icon-' + _vm.icon
  }) : _vm._e()]), _vm._v(" "), _vm._t("title", [_c('span', {
    staticClass: "zan-cell__text",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (_vm.label) ? _c('span', {
    staticClass: "zan-cell__label",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "zan-cell__value",
    class: {
      'is-link': _vm.isLink,
      'is-alone': !this.$slots.title && !_vm.title && !_vm.label
    }
  }, [_vm._t("default", [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.value)
    }
  })])], 2), _vm._v(" "), (_vm.isLink) ? _c('i', {
    staticClass: "zan-icon zan-icon-arrow"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78cd79e1!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/cell/src/cell.vue
// module id = 175
// module chunks = 0 2